export const nativeEvents = {
    customerDataReload: 'native:customer-data-reload'
};

window.require(['jquery'], ($) => {
    $(document).on('customer-data-reload', (event, data) => {
        window.dispatchEvent(
            new CustomEvent(nativeEvents.customerDataReload, { detail: data })
        );
    });
});
